const messages = {
  "ui.entityFieldSelector.company": "Company",
  "ui.entityFieldSelector.deal": "Deal",
  "ui.entityFieldSelector.person": "Person",
  "ui.entityFieldSelector.search.placeholder": "Search for fields",
} as const;

export default messages;
